import React, { RefObject } from 'react';
import { Translate } from 'react-redux-i18n';
import { Form } from 'react-final-form';
import icone from '../../../img/createAccount/identite.svg';
import DoublonAccountTile from './DoublonAccountTile';
import { PersonneActivationDedoublonnageDTO } from '../../../network/api/types/activation/PersonneActivationDedoublonnageDTO';
import Button from '../../common/Button';
import { ActivationDTO } from '../../../network/api/types/activation/ActivationDTO';

type Props = {
  divRef: RefObject<HTMLDivElement>,
  isLoading: boolean,
  duplicateAccounts: PersonneActivationDedoublonnageDTO[],
  endForm: (values: ActivationDTO) => void,
};

type Form = {
  duplicatesUids: string[];
};

class ActivationDoublon extends React.PureComponent<Props> {
  handleSubmit = async (formValues: Form): Promise<void> => {
    this.props.endForm(formValues);
  };

  render(): React.ReactNode {
    const {
      divRef, duplicateAccounts, isLoading,
    } = this.props;

    return (
      <div ref={divRef} className="account-activation-form-container">
        <div className="account-activation-col">
          <h3><Translate value="ACTIVATION.EXISTING_ACCOUNT" /></h3>
        </div>
        <div className="account-activation-col">
          <Translate className="information-text" value="ACTIVATION.REMOVE_DUPLICATE" />
          <Translate className="information-text" value="ACTIVATION.REMOVE_DUPLICATE_2" />
          <Form
            onSubmit={this.handleSubmit}
            initialValues={{
              duplicatesUids: duplicateAccounts
                .map((account: PersonneActivationDedoublonnageDTO) => account.uid),
            }}
            render={(
              {
                handleSubmit,
                submitError,
              },
            ) => (
              <form className="connection-information-form" onSubmit={handleSubmit}>
                {submitError && <div className="error">{submitError}</div>}
                <div className="accounts">
                  {duplicateAccounts.map((account: PersonneActivationDedoublonnageDTO) => (
                    <DoublonAccountTile
                      isLoading={isLoading}
                      account={account}
                      endForm={duplicateAccounts.length === 1 ? handleSubmit : undefined}
                    />
                  ))}
                </div>
                <div className="button-container">
                  {duplicateAccounts.length > 1 && (
                    <Button
                      type="primary"
                      buttonType="submit"
                      i18nKey="ACTIVATION.DELETE_AND_END"
                      isLoading={isLoading}
                    />
                  )}
                </div>
              </form>
            )}
          />
        </div>
        <div className="account-activation-col">
          <div>
            <img className="logo" src={icone} alt="" />
          </div>
          <div className="multiple-span">
            <Translate value="ACTIVATION.EXISTING_ACCOUNT_HINT" />
          </div>
        </div>
      </div>
    );
  }
}

export default ActivationDoublon;
